import { OverlayDialog, RenderHtml } from '@flos/react-components';
import { Button } from '@material-ui/core';
import { baseStyles } from '../../theme/base.styles';

const NonDomesticAddressOverlay = ({
  isInvalidAddress,
  setIsInvalidAddress,
  appConfig
}: {
  isInvalidAddress: boolean;
  setIsInvalidAddress: any;
  appConfig: any;
}): JSX.Element => {
  const foreignAddress = appConfig.contentBlocks['domestic-address-rejection'].read();
  const baseClasses = baseStyles();
  const commonLabels = appConfig.resourceBundles['dk.onsa-common'].read();
  const closeForeignAddressOverlay = () => {
    setIsInvalidAddress(false);
    window.location.assign(window.location.origin + '/forsikringer/rejseforsikring');
  };
  const onRedirectHandler = () => {
    window.location.assign(`${window.location.origin}/faa-hjaelp/kontakt-os/`);
  };
  return (
    <OverlayDialog open={isInvalidAddress} onClose={closeForeignAddressOverlay} transitionDuration={0}>
      <RenderHtml html={foreignAddress.data} className={baseClasses.htmlWrapper} />
      <Button fullWidth variant="contained" onClick={() => onRedirectHandler()}>
        {commonLabels['button.contact']}
      </Button>
    </OverlayDialog>
  );
};

const CustomerMarkingOverlay = ({
  isOpen,
  setIsOpen,
  appConfig
}: {
  isOpen: boolean;
  setIsOpen: any;
  appConfig: any;
}): JSX.Element => {
  const baseClasses = baseStyles();
  const cb_cr = appConfig.contentBlocks['customer-rejection'].read();
  const closeOverlay = () => {
    setIsOpen(false);
    window.location.assign(window.location.origin + '/forsikringer/rejseforsikring/');
  };
  return (
    <OverlayDialog open={isOpen} onClose={closeOverlay} transitionDuration={0}>
      <RenderHtml html={cb_cr.data} className={baseClasses.htmlWrapper} />
    </OverlayDialog>
  );
};

const BornholmOverlay = ({
  isOpen,
  setIsOpen,
  appConfig
}: {
  isOpen: boolean;
  setIsOpen: any;
  appConfig: any;
}): JSX.Element => {
  const baseClasses = baseStyles();
  const cb_cr_b = appConfig.contentBlocks['customer-rejection-bornholm'].read();
  const commonLabels = appConfig.resourceBundles['dk.onsa-common'].read();
  const onRedirectHandler = () => {
    setIsOpen(false);
    window.location.assign('https://bornbrand.dk/privat/%C3%A5rsrejseforsikring/');
  };
  const onCloseHandler = () => {
    setIsOpen(false);
    window.location.assign(`${window.location.origin}/forsikringer/rejseforsikring/`);
  };
  return (
    <OverlayDialog open={isOpen} onClose={onCloseHandler} transitionDuration={0}>
      <RenderHtml html={cb_cr_b.data} className={baseClasses.htmlWrapper} />
      <Button fullWidth variant="contained" onClick={() => onRedirectHandler()}>
        {commonLabels['button.bornholm']}
      </Button>
    </OverlayDialog>
  );
};

const EdiOverlay = ({ isOpen, setIsOpen, appConfig }: { isOpen: boolean; setIsOpen: Function; appConfig: any }) => {
  const baseClasses = baseStyles();
  const ediText = appConfig.contentBlocks['common/edi-overlay-text']?.read();

  const onCloseHandler = () => {
    setIsOpen(false);
  };

  return (
    <OverlayDialog open={isOpen} onClose={onCloseHandler} transitionDuration={0}>
      <RenderHtml html={ediText?.data} className={baseClasses.htmlWrapper} />
    </OverlayDialog>
  );
};

export { NonDomesticAddressOverlay, CustomerMarkingOverlay, BornholmOverlay, EdiOverlay };
